import { DefaultValues } from 'react-hook-form';

import { ILoanListGroupFilterResponse } from '@patient-fi/fed-types';

import { EFilterType } from '../consts/ETypeFilter';

function mapFiltersDefaultValues(filters: ILoanListGroupFilterResponse[]): DefaultValues<Record<string, unknown>> {
  if (!filters || filters.length === 0) {
    return {};
  }

  return Object.fromEntries(
    filters
      .map((filter) =>
        filter.filters.map((filterItem) => {
          let { value } = filterItem;
          if (filterItem.filterScheme.filterType === EFilterType.SELECT && filterItem.filterScheme.multiSelect && !Array.isArray(value)) {
            value = [value].filter(Boolean);
          }
          return [filterItem.filterScheme.filterQueryName, value];
        }),
      )
      .flat()
      .filter(([, value]) => value !== undefined && value !== null),
  );
}

export default mapFiltersDefaultValues;
